<template>
  <div>
    <y-dialog
      title="请选择店铺"
      :visible.sync="visible"
      width="1200px"
      :before-close="handleDialogClose"
      append-to-body
      @comfirm="handleDialogConfirm"
      @close="handleDialogClose"
      sureText="保存"
    >
      <div class="choose-shop global-content-flex">
        <el-tabs class="myTabs" v-model="activeName" @tab-click="tabChange">
          <el-tab-pane label="全部店铺" name="first"> </el-tab-pane>
          <el-tab-pane label="已选店铺" name="second"> </el-tab-pane>
        </el-tabs>
        <template v-if="activeName == 'first'">
          <!-- 查询区 -->
          <div class="screen-box">
            <div class="item" style="margin-top: 10px">
              <span class="item-name" style="font-size: 12px">店铺信息：</span>
              <el-select
                v-model="searchForm.platform"
                style="width: 146px; margin: 0 8px"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in $platformList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                class="short-input"
                style="width: 180px; margin-right: 30px"
                placeholder="请输入店铺名称"
                size="small"
                v-model="searchForm.shopTitle"
              ></el-input>
              <y-button
                type="blue"
                :disabled="tableLoading"
                @click="
                  (pageInfo.pageNum = 1),
                    (pageInfo.pageSize = 10),
                    searchList(1)
                "
                >查询</y-button
              >
              <y-button
                type="default"
                :disabled="tableLoading"
                @click="searchList(0)"
                >重置</y-button
              >
            </div>
          </div>
          <!-- 操作 -->
          <div class="first_toolTop">
            <div>
              <!-- 暂时去除 -->
              <!-- <el-checkbox v-model="checkAll">全选全部</el-checkbox> -->
            </div>
            <el-checkbox v-model="searchForm.selection" @change="showSelectAble"
              >仅显示可选项</el-checkbox
            >
          </div>
          <!-- 全部店铺表格 -->
          <div class="global-felx-1">
            <y-table
              :tableInfo="allShopInfo"
              :pageInfo="pageInfo"
              :selection="true"
              rowKey="channelSellerManageId"
              :selectable="checkboxT"
              :loading="tableLoading"
              ref="tableRef"
              :tableData="tableData"
              @handleSelectionChange="handleSelectionChange"
              @selectAll="handleSelectAll"
              @handleSelect="handleSelectRow"
              @handlePage="handlePage"
            >
            </y-table>
          </div>
        </template>
        <template v-else-if="activeName == 'second'">
          <!-- 头部操作 -->
          <div class="second_toolTop">
            <y-button type="blueText" @click="removeAll(2)">移除全部</y-button>
            <!-- <div @click="removeAll(3)">移除当页</div> -->
          </div>
          <!-- 已选数据表格 -->
          <div class="global-felx-1">
            <y-table
              :tableInfo="selectedInfo"
              :pageInfo="pageInfo2"
              :loading="tableLoading2"
              :tableData="tableData2"
              @handlePage="handlePage2"
            >
              <template #edit="scope">
                <y-button
                  type="blueText"
                  @click="removeRow(scope.row)"
                  :disabled="scope.row.isDisable"
                  >移除</y-button
                >
              </template>
            </y-table>
          </div>
        </template>
      </div>
    </y-dialog>
    <y-dialog
      title="提示"
      :visible.sync="sureDialogVisible"
      width="452px"
      top="40vh"
      @comfirm="deleteConfirm(delType)"
      @close="sureDialogVisible = false"
    >
      <div class="sure_text">
        <img src="@/assets/images/waring.png" />
        <span v-if="delType == 1">确定移除该店铺?</span>
        <span v-if="delType == 2">确定移除全部已选店铺?</span>
        <span v-if="delType == 3">确定移除当页已选店铺?</span>
      </div>
    </y-dialog>
  </div>
</template>

<script>
import {
  scoresBindList,
  isScoresBindList,
} from "@/api/integralCenter/newMemberSystem";
import { unbindList } from "@/api/manage/scoreList";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      MemberSystemInfo: {}, // 当前会员体系详情
      activeName: "first",
      // 全部店铺
      searchForm: {
        platform: "",
        shopTitle: "",
        selection: false,
      },
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      tableData: [], // 全部店铺表格数据
      // 已选店铺
      searchForm2: {
        platFrom: "",
        shopTitle: "",
      },
      pageInfo2: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      tableData2: [], // 已选店铺表格数据
      tableLoading: false,
      tableLoading2: false,
      checkAll: false, // 全选
      selectList: [], // 选中项
      selectIdList: [], // 选中项ID
      sureDialogVisible: false, // 删除提示
      delType: 1,
      rowData: {},

      allShopInfo: [
        {
          prop: "channelSellerManageId",
          label: "店铺ID",
        },
        {
          prop: "shopTitle",
          label: "店铺名称",
        },
        {
          prop: "platform",
          formatter: (row) => {
            if (row.platform == 1) {
              return "淘宝";
            } else if (row.platform == 2) {
              return "京东";
            } else if (row.platform == 3) {
              return "有赞";
            } else if (row.platform == 5) {
              return "抖音";
            } else if (row.platform == 6) {
              return "快手";
            } else {
              return "-";
            }
          },
          label: "平台",
        },
        {
          prop: "type",
          label: "店铺类型",
        },
        {
          prop: "bindTime",
          label: "创建日期",
        },
      ],
      selectedInfo: [
        {
          prop: "channelSellerManageId",
          label: "店铺ID",
        },
        {
          prop: "shopTitle",
          label: "店铺名称",
        },
        {
          prop: "platform",
          formatter: (row) => {
            if (row.platform == 1) {
              return "淘宝";
            } else if (row.platform == 2) {
              return "京东";
            } else if (row.platform == 3) {
              return "有赞";
            } else if (row.platform == 5) {
              return "抖音";
            } else if (row.platform == 6) {
              return "快手";
            } else {
              return "-";
            }
          },
          label: "平台",
        },
        {
          prop: "type",
          label: "店铺类型",
        },
        {
          prop: "bindTime",
          label: "创建日期",
        },
        {
          prop: "edit",
          slot: "edit",
          label: "操作",
        },
      ],
    };
  },
  created() {
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    console.log(this.MemberSystemInfo);
  },
  mounted() {
    this.selectIdList = [...this.selected];
    console.log(this.selected);
    // 进入页面获取全部数据,通过id使已选店铺回显
    scoresBindList({ pageNum: 1, pageSize: 500, selection: 0 }).then((res) => {
      let dataList = res.data.dataList;
      this.selectIdList.forEach((item) => {
        dataList.forEach((item2) => {
          if (item == item2.channelSellerManageId && item2.selected == 0) {
            this.selectList.push(item2);
          }
        });
      });
    });
    this.searchList(1);
  },
  watch: {
    // 监听是否全选全部
    checkAll(newVal, oldVal) {
      if (newVal) {
        // 全选
        // 手动选中可选项
        this.checkAllFn();
      } else {
        // 清除全部选项
        this.$refs.tableRef.handleClearSelection();
      }
    },
    // selectList(newVal) {
    //   this.selectIdList = []
    //   newVal.forEach(item => {
    //     this.selectIdList.push(item.channelSellerManageId)
    //   })
    // }
  },
  methods: {
    // 切换tab
    tabChange() {
      if (this.activeName == "first") {
        this.searchList(1)
      } else if (this.activeName == "second") {
        this.searchList2(1);
      }
    },
    // 显示可选项
    showSelectAble() {
      this.pageInfo.pageSize = 10;
      this.pageInfo.pageNum = 1;
      this.searchList(1);
    },
    // 查询全部店铺
    searchList(type) {
      let obj = {};
      this.tableLoading = true;
      // 查询
      if (type) {
        obj = {
          // ...this.searchForm,
          selection: this.searchForm.selection ? 1 : 0,
          platform: this.searchForm.platform,
          shopTitle: this.searchForm.shopTitle,
          pageNum: this.pageInfo.pageNum,
          pageSize: this.pageInfo.pageSize,
        };
        if (!obj.platform) delete obj.platform;
        if (!obj.shopTitle) delete obj.shopTitle;
      } else {
        // 重置
        this.pageInfo = {
          pageSize: 10,
          pageNum: 1,
          total: 0,
        };
        obj = {
          pageNum: this.pageInfo.pageNum,
          pageSize: this.pageInfo.pageSize,
          selection: 0,
        };
        this.searchForm.platform = "";
        this.searchForm.shopTitle = "";
        this.searchForm.selection = false;
      }
      console.log(obj);
      scoresBindList(obj)
        .then((res) => {
          this.tableData = res.data.dataList;

          this.pageInfo.total = res.data.pageInfo.total;
          this.$nextTick(() => {
            this.tableLoading = false;
            // 勾选了全选全部
            if (this.checkAll == true) {
              this.checkAllFn();
            }
            console.log(this.selectList, this.selectIdList);
            // 回显已勾选数据
            if (this.selectList.length) {
              this.selectList.forEach((item) => {
                this.tableData.forEach((item2) => {
                  if (
                    item.channelSellerManageId == item2.channelSellerManageId &&
                    item2.selected == 0
                  ) {
                    this.$refs.tableRef.toggleRowSelection(item2, true);
                  }
                });
              });
            }
            this.selectIdList.forEach((item) => {
              this.tableData.forEach((item2) => {
                if (
                  item == item2.channelSellerManageId &&
                  item2.selected == 0
                ) {
                  this.$refs.tableRef.toggleRowSelection(item2, true);
                  if (
                    this.selectList.findIndex(
                      (lab) => lab.channelSellerManageId == item
                    ) == -1
                  ) {
                    this.selectList.push(item2);
                  }
                }
              });
            });
          });
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 查询已选店铺
    searchList2(type) {
      this.tableLoading2 = true;
      let obj = {};
      if (type) {
        obj = {
          scoresCardId: this.MemberSystemInfo.scoresCardId,
          pageNum: this.pageInfo2.pageNum,
          pageSize: this.pageInfo2.pageSize,
        };
      } else {
        // 重置
        this.pageInfo = {
          pageSize: 10,
          pageNum: 1,
          total: 0,
        };
        obj = {
          scoresCardId: this.MemberSystemInfo.scoresCardId,
          pageNum: this.pageInfo2.pageNum,
          pageSize: this.pageInfo2.pageSize,
        };
      }
      // 已选店铺数量
      // let selectLength = this.selectList.length
      // // 如果有选择店铺,开始合并数据
      // if (selectLength) {
      //   this.pageInfo2.total = selectLength
      //   let pageTotal = this.pageInfo2.pageNum * this.pageInfo2.pageSize
      //   console.log(Math.floor(selectLength / pageTotal), selectLength % pageTotal);
      //   // this.selectList.forEach(item=>{
      //   //   this.tableData2.push({ ...item, scoresCardSellerId: item.channelSellerManageId })
      //   // })
      //   isScoresBindList(obj).then(res => {
      //     res.data.dataList.forEach(item => {
      //       item.isDisable = true
      //     })
      //     this.pageInfo2.total += res.data.pageInfo.total
      //     this.tableLoading2 = false
      //     // this.selectList.forEach(item => {
      //     //   this.tableData2.unshift({ ...item, scoresCardSellerId: item.channelSellerManageId })
      //     // })
      //   })
      // } else { // 无选择数据,直接查询
      isScoresBindList(obj).then((res) => {
        this.tableData2 = res.data.dataList;
        this.tableData2.forEach((item) => {
          item.isDisable = true;
        });
        this.pageInfo2.total = res.data.pageInfo.total;
        if (this.selectList.length) {
          // this.pageInfo2.total += this.selectList.length
          this.selectList.forEach((item) => {
            this.tableData2.unshift({
              ...item,
              scoresCardSellerId: item.channelSellerManageId,
            });
          });
        }
        this.tableLoading2 = false;
      });
      // }
    },
    // 全部店铺--设置当前行是否可勾选
    checkboxT(row, index) {
      if (row.selected) {
        return false;
      } else {
        return true;
      }
    },
    // 全选全部
    checkAllFn() {
      this.tableData.forEach((item) => {
        if (!item.selected) this.$refs.tableRef.toggleRowSelection(item, true);
      });
      // this.$refs.tableRef.toggleAllSelection()
    },
    // 表格多选框选择
    handleSelectionChange(list) {
      // this.selectList.push(...list)
      // let map = new Map()
      // for (let item of this.selectList) {
      //   if (!map.has(item.channelSellerManageId)) {
      //     map.set(item, item);
      //   }
      // }
      // this.selectList = [...map.values()]
    },
    // 选择行
    handleSelectRow(list, row) {
      let index = this.selectList.findIndex(
        (item) => item.channelSellerManageId == row.channelSellerManageId
      );
      let index2 = this.selectIdList.findIndex(
        (item) => item == row.channelSellerManageId
      );
      if (index != -1) {
        this.selectList.splice(index, 1);
      } else {
        this.selectList.push(row);
      }
      console.log(index2);
      if (index2 == -1) {
        this.selectIdList.push(row.channelSellerManageId);
      } else {
        this.selectIdList.splice(index2, 1);
      }
      // this.selectIdList = this.selectList.map(item => item.channelSellerManageId)
      console.log(this.selectIdList);
    },
    // 选择全部
    handleSelectAll(val) {
      // 取消全选删除当前页勾选数据
      if (!val.length) {
        let list = this.tableData.filter((item) => item.selected == 0);
        list.forEach((item) => {
          this.selectList.forEach((item2, index) => {
            if (item.channelSellerManageId == item2.channelSellerManageId) {
              this.selectList.splice(index, 1);
            }
          });
          this.selectIdList.forEach((item2, index) => {
            if (item.channelSellerManageId == item2) {
              this.selectIdList.splice(index, 1);
            }
          });
        });
      } else {
        // 全选当前页数据
        this.selectList.push(...val);
        this.selectList = [
          ...new Map(
            this.selectList.map((item) => [item.channelSellerManageId, item])
          ).values(),
        ];
        this.selectIdList = this.selectList.map(
          (item) => item.channelSellerManageId
        );
      }
    },
    // 移除当前行
    removeRow(row) {
      this.delType = 1;
      this.rowData = row;
      this.sureDialogVisible = true;
    },
    // 删除确认
    deleteConfirm(val) {
      if (val == 1) {
        this.sureDialogVisible = false;
        this.selectList = this.selectList.filter(
          (item) =>
            item.channelSellerManageId != this.rowData.scoresCardSellerId
        );
        this.selectIdList = this.selectIdList.filter(
          (item) => item != this.rowData.scoresCardSellerId
        );
        this.searchList(1);
        this.searchList2(1);
      } else if (val == 2) {
        this.sureDialogVisible = false;
        this.selectList = [];
        this.selectIdList = this.tableData2
          .filter((item) => item.isDisable)
          .map((item) => item.scoresCardSellerId);
        this.searchList(1);
        this.searchList2(1);
        console.log(this.selectList, this.selectIdList);
      } else if (val == 3) {
      }
    },
    // 移除全部/当页数据
    removeAll(val) {
      if (this.selectList.length == 0) {
        return this.$message.warning("请先选择店铺");
      } else if (
        this.tableData2.filter((item) => !item.isDisable).length == 0
      ) {
        return this.$message.warning("当前页没有可移除店铺");
      }
      this.delType = val;
      this.sureDialogVisible = true;
    },
    handlePage(val) {
      this.pageInfo.pageNum = val.pageNum;
      this.pageInfo.pageSize = val.pageSize;
      this.searchList(1);
    },
    handlePage2(val) {
      this.pageInfo2.pageNum = val.pageNum;
      this.pageInfo2.pageSize = val.pageSize;
      this.searchList2(1);
    },
    // 保存
    handleDialogConfirm() {
      // if (this.checkAll) {
      //   unbindList().then(res => {
      //     this.selectList = []
      //     res.data.forEach(item => {
      //       this.selectList.push(item.shopId)
      //     })
      //     this.$emit("save", this.selectList);
      //   })
      // } else {
      console.log(111111);
      this.$emit(
        "update:selected",
        JSON.parse(JSON.stringify(this.selectIdList))
      );
      this.$emit("close", false);
      // }
    },
    // 关闭前
    handleDialogClose() {
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.choose-shop {
  height: 666px;
}
.sure_text {
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  color: #333333;

  img {
    margin-right: 20px;
  }
}

.cont_tips {
  position: absolute;
  top: 60px;
  left: 195px;
  z-index: 50;
}

.screen-box {
  .item {
    display: inline-block;
    vertical-align: middle;

    .searchBtn {
      width: 88px;
      height: 32px;
      background: #fff;
      border: 1px solid #1f4287;
      opacity: 1;
      border-radius: 6px;
      font-weight: 400;
      line-height: 12px;
      color: #fff;
      background: #1f4287;
      margin-left: 20px;

      &:hover {
        background: #2551a8;
        border: 1px solid #2551a8;
        color: #fff;
      }
    }

    .resetBtn {
      width: 88px;
      height: 32px;
      background: #fff;
      border: 1px solid #1f4287;
      opacity: 1;
      border-radius: 6px;
      font-weight: 400;
      line-height: 12px;
      color: #1f4287;

      &:hover {
        background: #1f4287;
        border: 1px solid #1f4287;
        color: #fff;
      }
    }
  }
}

.second_toolTop {
  display: flex;
  justify-content: right;

  > div {
    color: #1f4287;
    cursor: pointer;
  }

  > div:nth-of-type(2) {
    margin-left: 20px;
  }

  margin: 20px 0;
  margin-top: 0;
}

.first_toolTop {
  display: flex;
  justify-content: space-between;
  margin: 20px 0px;
}
</style>
